"use client";

import React from "react";
import { motion } from "framer-motion";
import Image from "next/image";


import mobile from "@/assets/images/services/mobile-app/mobileImg.webp";
import "./IndustryGrowthSection.scss";
import { Container } from "react-bootstrap";

const IndustryGrowthSection = ({ industry }) => {
  const { title, description, cards } = industry;

  return (
    <section className="industry-floating-tags-section">
      <Container>
        <div className="industry-floating-tags-container">
          {/* HEADER */}
          <div className="section-top">
            <div className="left-content">
              <h2>{title}</h2>
            </div>

            <div className="right-content">
              <p>{description}</p>
            </div>
          </div>

          {/* FLOATING AREA */}
          <div className="floating-layout-wrapper">
            {/* CENTER PHONE IMAGE */}
            <div className="center-phone-wrapper">
              <Image
                src={mobile}
                alt="Industry App"
                priority
                className="phone-image"
              />
            </div>

            {/* FLOATING TAGS */}
            {cards.map((card) => {
              return (
                <motion.div
                  key={card.id}
                  className={`floating-card ${card.slug}`}
                  animate={{
                    y: [0, -12, 0],
                  }}
                  transition={{
                    duration: card.duration,
                    repeat: Infinity,
                    ease: "easeInOut",
                  }}
                >
                  <div className="icon-wrapper">
                    <Image src={card.icon} alt={card.title} />
                    {/* {IconComponent && (
                      <IconComponent size={16} strokeWidth={1.8} />
                    )} */}
                  </div>

                  <div className="card-content">
                    <h6>{card.title}</h6>
                    <p>{card.description}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default IndustryGrowthSection;
